import { DefaultTheme } from 'styled-components';
import { BaseOptions } from '../declarations/styled';
import { Colours } from './colours';

const ThemeColours = {
  PrimaryColour: Colours.PRIMARY,
  SecondaryColour: Colours.SECONDARY,
  TertiaryColour: Colours.TERTIARY,
  TextColour: Colours.BLACK,
  HighlightColour: Colours.PRIMARY,
  HighlightTextColour: Colours.BLACK,
  ButtonBackgroundColour: "#bd422a",
  ButtonTextColour: Colours.WHITE,
  ButtonRadius: "0px",
};

const AnimationSettings = {
  AnimationTimingFast: '0.3s',
  AnimationTimingMedium: '0.5s',
  AnimationTimingSlow: '1s',
}

const BaseSettings: BaseOptions = {
  BorderRadius: '0.625em',
  DropShadowColor: Colours.BLACK,
  DropShadowAlpha: 0.2,
  DropShadowPlacement: '0px 3px 6px',
}

export const MonteCarloTheme: DefaultTheme = {
  Id: "scc-montecarlo",
  ...ThemeColours,
  ...AnimationSettings,
  Base: BaseSettings,
  Grid: {
    Columns: 12,
    GutterSize: '1em',
    Breakpoints: {
      SM: 600,
      MD: 760,
      LG: 900,
      XL: 1200,
      MAX: 1500,
    },
  },
  Splash: {
    BackgroundImageUrl: "https://sccmontecarlo.blob.core.windows.net/images/splash-background.jpg",
    LogoImageUrl: "https://sccmontecarlo.blob.core.windows.net/images/ident.png",
    VideoUrl: null
  },
  Header: {
    BackgroundColour: Colours.PRIMARY,
    TextColour: Colours.WHITE,
    LockupImageUrl: "https://sccmontecarlo.blob.core.windows.net/images/lock-up.png",
    LockupImageUrl_Additional: ""
  },
  Home: {
    LowerBackgroundImageUrl: "https://sccmontecarlo.blob.core.windows.net/images/home-lower-bg.jpg",
    PrizeSummaryBackgroundImageUrl: "https://sccmontecarlo.blob.core.windows.net/images/home-prizes-bg.jpg",
    ActionBarBackgroundColor: "#d1b895",
    ActionBarTextColor: Colours.WHITE
  },
  Nav: {
    TextColour: Colours.WHITE,
    HoverColour: Colours.WHITE,
    TextDecoration: 'none',
    TextDecorationOnHover: 'none',
  },
  Card: {
    BorderRadius: BaseSettings.BorderRadius,
    ContentMargin: '1em',
    ContentPadding: '1em',
    BackgroundColor: Colours.WHITE,
    HasDropShadow: false,
    DropShadowColor: BaseSettings.DropShadowColor,
    DropShadowAlpha: BaseSettings.DropShadowAlpha,
    DropShadowPlacement: BaseSettings.DropShadowPlacement,
  },
  ListItem: {
    BorderWidth: "1px",
    BorderColor: "#f9cea4",
    BorderStyle: "solid",
    BorderRadius: "5px"
  },
  DividerImageUrl: "https://sccmontecarlo.blob.core.windows.net/images/divider.png",
  DealSummary: {
    BackgroundColor: "#fff",
    BorderWidth: "3px",
    BorderRadius: "0px",
    Opacity: "80%",
    BorderColor: "#bd422a",
    BorderStyle: "solid"
  },
  Leaderboard: {
    RowBackgroundColour: "#f8f4ee"
  }
};
